<template>
  <div id="pivotContainer">The component will appear here</div>
</template>

// <script>
// import { VuePivottable, VuePivottableUi } from "vue-pivottable";
// import "vue-pivottable/dist/vue-pivottable.css";
// import PivotService from "@/services/PivotService";
import Flexmonster from "flexmonster";
import "flexmonster/flexmonster.min.css";

export default {
  components: {
    // VuePivottable,
    // VuePivottableUi
  },
  data() {
    return {
      //   pivotData: [
      //     // [
      //     //   "Revenue Collected",
      //     //   "Total Booking",
      //     //   "Show Time",
      //     //   "Cinema Name",
      //     //   "Movie Name"
      //     // ]
      //     // [9300, 11, "07:00", "PVR Milap", "Test Movie"],
      //     // [1000, 1, "07:00", "PVR Milap", "Test Movie"],
      //     // [1000, 1, "20:00", "PVR Milap", "Test Movie"],
      //     // [300, 1, "18:00", "PVR Milap", "Test Movie"]
      //   ],
      //   aggregatorName: "Sum",
      //   rendererName: "Table Heatmap",
      //   rows: ["Cinema Name"],
      //   cols: ["Revenue Collected"],
      //   vals: ["Total Booking"],
      //   disabledFromDragDrop: ["Movie Name", "Show Time"],
      //   hiddenFromDragDrop: ["Total Booking"]
    };
  },
  mounted() {
    new Flexmonster({
      container: "pivotContainer",
      componentFolder: "node_modules/flexmonster/",
      toolbar: true,
      report: {
        dataSource: {
          type: "api",
          url: "http://localhost:9500",
          index: "index_database"
        },
        slice: {
          rows: [
            { uniqueName: "CinemaName" },
            { uniqueName: "MovieName" },
            { uniqueName: "ScreenName" }
          ],
          columns: [{ uniqueName: "ShowDate" }],
          measures: [{ uniqueName: "GrossRevenue", aggregation: "sum" }]
        }
      },
      licenseKey: "Z74K-XA240U-6R320A-4Y1R0J"
    });
  },
  // mounted() {
  //   PivotService.GetPivotData()
  //     .then(response => {
  //       const { data } = response;
  //       if (data.status) {
  //         const result = data.Records.map(
  //           ({
  //             revenue,
  //             total_booking,
  //             t_show_time,
  //             cinema_name,
  //             movie_name
  //           }) => [revenue, total_booking, t_show_time, cinema_name, movie_name]
  //         );
  //         this.pivotData.push([
  //           "Revenue Collected",
  //           "Total Booking",
  //           "Show Time",
  //           "Cinema Name",
  //           "Movie Name"
  //         ]);
  //         this.pivotData = this.pivotData.concat(result);
  //         // this.pivotData[0] = result;
  //         console.log("this.pivotData :>> ", this.pivotData);
  //       } else {
  //         this.$toasted.show(data.message);
  //       }
  //     })
  //     .catch(err => {
  //       this.$toasted.show(err);
  //     });
  // },
  methods: {
    toggle: function(todo) {
      todo.done = !todo.done;
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/pivot.vue